import * as types from './action_types'
import { defaultInstance as defaultFavoritesClient } from '@xo-union/sdk-favorites';
import { defaultService as membershipService } from '@xo-union/sdk-membership';

export function clearFavorites() {
  return (dispatch, getState) => {
    let categoryName = getCategoryName();

    dispatch(clear());
  };
}

export function clearToast() {
  return (dispatch, getState) => {
    dispatch({ type: types.CLEAR_TOAST });
  }
}

export function fetchPageFavorites() {
  return (dispatch, getState, { favoritesClient = defaultFavoritesClient } = {}) => {
    let memberId = getState().membership.member.id;
    let sessionToken = getSessionToken();
    let productIds = getProductIds();
    let categoryName = getCategoryName();
    let requestData = {sessionToken: sessionToken, query: {member_uuid: memberId, object_ids: productIds.toString(), categories: categoryName, per_page: 46}};

    favoritesClient
      .get(requestData)
      .then(response => {
        dispatch(fetchSuccess(response.body.favorites));
      });
  };
}

export function fetchFavoritesCount() {
  return (dispatch, getState, { favoritesClient = defaultFavoritesClient } = {}) => {
    let memberId = getState().membership.member.id;
    let sessionToken = getSessionToken();
    let categoryName = getCategoryName();
    let requestData = {sessionToken: sessionToken, query: {member_uuid: memberId, categories: categoryName, per_page: 100}};

    favoritesClient
      .get(requestData)
      .then(response => {
        dispatch(updateFavoritesCount(response.body.favorites.length));
      });
  };
}

export function loveImage(data) {
  return (dispatch, getState, { favoritesClient = defaultFavoritesClient } = {}) => {
    let categoryName = getCategoryName();
    data.member_uuid = getState().membership.member.id;
    const requestData = {sessionToken: getSessionToken(), data: data};

    favoritesClient
      .create(requestData)
      .then(response => {
        dispatch(love(response.body.favorites[0]));
        Fashion.Helpers.AnalyticsHelpers.trackAddFavoriteEvent(data.object);
      });
  };
}

export function unloveImage(favorite_id, product_id) {
  return (dispatch, getState, { favoritesClient = defaultFavoritesClient } = {}) => {
    let categoryName = getCategoryName();
    const requestData = {sessionToken: getSessionToken(), favoriteUUID: favorite_id, query: {member_uuid: getState().membership.member.id}};

    favoritesClient
      .destroy(requestData)
      .then(response => {
        dispatch(unlove(favorite_id));
        Fashion.Helpers.AnalyticsHelpers.trackRemoveFavoriteEvent(product_id);
      });
  };
}

function clear() {
  return { type: types.CLEAR };
}

function love(favorite) {
  return {
    type: types.LOVE,
    favorite
  };
}

function unlove(favorite_id) {
  return {
    type: types.UNLOVE,
    favorite_id
  };
}

function fetchSuccess(favorites) {
  return {
    type: types.FETCH_SUCCESS,
    favorites
  };
}

function updateFavoritesCount(count) {
  return {
    type: types.UPDATE_FAVORITES_COUNT,
    count
  }
}

function getProductIds() {
  if(XO.metadata.page_data.kind === 'detail') { return [XO.metadata.entities.primary_entity_id] }

  let entities = XO.metadata.entities || {};
  let ids = Object.keys(entities);
  let deleteIndex = ids.indexOf('primary_entity_id');
  if(deleteIndex > -1) {
    ids.splice(deleteIndex, 1)
  }

  return ids
}

function getCategoryName() {
  let name = '';
  let entities = XO.metadata.entities || {};
  let entity = entities[entities.primary_entity_id];

  if(entity) {
    name = entity.terms.category_name;
  }

  return name;
}

function getSessionToken(){
  return membershipService.getSessionToken();
}
